module.exports = __webpack_public_path__ + "static/quoteAuthor-f87f0a331ad2eee0c8c9c40c16e99e3c.svg";